module.exports = __webpack_public_path__ + "static/img/banner-joinus-01.93c5c52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-joinus-01.jpg
// module id = wWUw
// module chunks = 98